<template>
  <div style="padding: 24px;background: #fff;">
    <div class="table-page-search-wrapper" style="margin-bottom:10px;">
      <a-form layout="inline">
        <a-form-item>
          <a-range-picker
            :ranges="{
              昨天: [
                moment()
                  .day(moment().day() - 1)
                  .startOf('day'),
                moment()
                  .day(moment().day() - 1)
                  .endOf('day')
              ],
              上周: [
                moment()
                  .week(moment().week() - 1)
                  .startOf('week'),
                moment()
                  .week(moment().week() - 1)
                  .endOf('week')
              ],
              上个月: [
                moment()
                  .month(moment().month() - 1)
                  .startOf('month'),
                moment()
                  .month(moment().month() - 1)
                  .endOf('month')
              ],
              上个季度: [
                moment()
                  .quarter(moment().quarter() - 1)
                  .startOf('quarter'),
                moment()
                  .quarter(moment().quarter() - 1)
                  .endOf('quarter')
              ]
            }"
            :value="dateTimeRange"
            :disabledDate="disabledDate"
            showTime
            format="YYYY-MM-DD HH:mm:ss"
            @change="onChangeDatePicker"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 30 }">
          <a-input
            placeholder="卡号或用户姓名查询"
            @change="changeSearchText"
          />
        </a-form-item>
        <a-form-item>
          <a-select
            :value="selectDepartment"
            @change="handleDepartment"
            style="width:150px"
          >
            <a-select-option value="">全部部门</a-select-option>
            <a-select-option
              v-for="item in departmentList"
              :key="item.id"
              :value="item.id"
              >{{ item.text }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 30 }">
          <a-select :value="consumeType" @change="changeConsumeType">
            <a-select-option value="">全部支付方式</a-select-option>
            <a-select-option value="1">点餐支付</a-select-option>
            <a-select-option value="2">刷卡支付</a-select-option>
            <a-select-option value="4">扫码枪扣费</a-select-option>
            <a-select-option value="3">睿吃扫码扣费</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 30 }">
          <a-select :value="cardType" @change="changeCardType">
            <a-select-option value="">全部类型卡</a-select-option>
            <a-select-option
              v-for="item in cardTypeList"
              :key="item.id"
              :value="item.id"
              >{{ item.text }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 30 }">
          <a-select :value="recordType" @change="changeRecordType">
            <a-select-option value="">全部记录类型</a-select-option>
            <a-select-option value="1">充值</a-select-option>
            <a-select-option value="2">消费</a-select-option>
            <a-select-option value="3">开户</a-select-option>
            <a-select-option value="4">退卡</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" style="margin-left: 0;" @click="search">
            <a-icon type="search" />查询 </a-button
          >&emsp;
        </a-form-item>
        <a-form-item>
          <a-button style="margin-left: 0;" @click="reset"> 重置 </a-button
          >&emsp;
        </a-form-item>
        <div style="float:right;">
          <a-button type="primary" style="margin-top: 4px;" @click="download">
            <a-icon type="cloud-download" />导出报表
          </a-button>
        </div>
      </a-form>
      <div style="clear:both"></div>
    </div>
    <!-- tongji  -->
    <a-card :bordered="false">
      <a-row>
        <a-col :sm="6">
          <head-info
            title="充值总额/笔数"
            :content="
              String(baseInfo.recharge) === 'undefined'
                ? '0/0'
                : String(baseInfo.recharge)
            "
            :bordered="true"
          />
        </a-col>
        <a-col :sm="6">
          <head-info
            title="消费总额/笔数"
            :content="
              String(baseInfo.consume) === 'undefined'
                ? '0/0'
                : String(baseInfo.consume)
            "
            :bordered="true"
          />
        </a-col>
        <a-col :sm="6">
          <head-info
            title="开户总额/笔数"
            :content="
              String(baseInfo.openAccount) === 'undefined'
                ? '0/0'
                : String(baseInfo.openAccount)
            "
            :bordered="true"
          />
        </a-col>
        <a-col :sm="6">
          <head-info
            title="退卡总额/笔数"
            :content="
              String(baseInfo.withdrawCard) === 'undefined'
                ? '0/0'
                : String(baseInfo.withdrawCard)
            "
          />
        </a-col>
      </a-row>
    </a-card>
    <!-- 表格 -->
    <a-table
      :columns="tableColumns"
      :dataSource="tableData"
      :loading="tableLoading"
      :pagination="pagination"
      bordered
      size="small"
    >
    </a-table>
  </div>
</template>
<script>
import moment from 'moment'
import HeadInfo from '@/components/tools/head-info'
import { GetCardTypeList } from '@/apis/card'
import { GetCardRecordList, DownloadRecordExcel } from '@/apis/report'
import { GetDepartmentDropdownList } from '@/apis/department'
import { getDateTimeRange } from '@/utils/base'

const tableColumns = [{
  title: '时间',
  dataIndex: 'time',
  key: 'time',
  align: 'center'
}, {
  title: '卡号',
  dataIndex: 'idCard',
  key: 'idCard',
  align: 'center'
}, {
  title: '姓名',
  dataIndex: 'staffName',
  key: 'staffName',
  align: 'center'
}, {
  title: '充值',
  dataIndex: 'recharge',
  key: 'recharge',
  align: 'center'
}, {
  title: '消费',
  dataIndex: 'expend',
  key: 'expend',
  align: 'center'
}, {
  title: '开户',
  dataIndex: 'openAccount',
  key: 'openAccount',
  align: 'center'
}, {
  title: '退卡',
  dataIndex: 'closeAccount',
  key: 'closeAccount',
  align: 'center'
}, {
  title: '余额',
  dataIndex: 'balance',
  key: 'balance',
  align: 'center'
}];


export default {
  data() {
    return {
      selectDepartment: '',
      departmentList: [],
      tableData: [],
      tableColumns,
      recordType: '',
      cardType: '',
      consumeType: '',
      searchText: '',
      dateTimeRange: [getDateTimeRange(), moment()],
      pagination: {
        onChange: (page, pageSize) => {
          this.pagination.current = page
          this.pagination.pageSize = pageSize
          this._GetCardRecordList()
        },
        total: 0,
        pageSize: 12,
        current: 1,
        size: 'middle',
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['12', '24', '36', '48'],
        defaultPageSize: 12,
        showSizeChanger: true,
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this._GetCardRecordList()
        }
      },
      tableLoading: false,
      baseInfo: {},
      cardTypeList: []
    }
  },
  methods: {
    // monment
    moment,
    _getCardTypeList() {
      GetCardTypeList().then(res => {
        if (res.data.state === 1) {
          this.cardTypeList = res.data.attribute
        }
      })
    },
    // 日期选择器
    disabledDate(current) {
      return current && current > moment().endOf('day');
    },
    onChangeDatePicker(date, dateString) {
      this.dateTimeRange = date
    },
    changeRecordType(value) {
      this.recordType = value
    },
    changeCardType(value) {
      this.cardType = value
    },
    changeConsumeType(value) {
      this.consumeType = value
    },
    // 选择部门
    handleDepartment(value) {
      this.selectDepartment = value
    },
    // 查询
    changeSearchText(e) {
      this.searchText = e.target.value
    },
    // 重置
    reset() {
      this.recordType = ''
      this.cardType = ''
      this.consumeType = ''
      this.searchText = ''
      this.dateTimeRange = [moment().day(moment().day() - 30).startOf('day'), moment()]
      this.pagination.current = 1
      this._GetCardRecordList()
    },
    search() {
      this.pagination.current = 1
      this._GetCardRecordList()
    },
    // 导出报表
    download() {
      let that = this
      that.$confirm({
        title: '您确定要下载充值消费记录报表吗？',
        content: '',
        onOk() {
          DownloadRecordExcel({
            startTime: that.dateTimeRange[0].format('YYYY-MM-DD HH:mm:ss'),
            endTime: that.dateTimeRange[1].format('YYYY-MM-DD HH:mm:ss'),
            type: that.recordType,
            consumeType: that.consumeType,
            cardTypeId: that.cardType,
            search: that.searchText,
            departmentId: that.selectDepartment
          }).then(res => {
            if (!res.data) {
              return
            }
            let url = window.URL.createObjectURL(new Blob([res.data]))
            let link = document.createElement('a')
            link.href = url
            link.setAttribute('download', '充值消费记录(' + that.dateTimeRange[0].format('YYYY-MM-DD') + '~' + that.dateTimeRange[1].format('YYYY-MM-DD') + ').xlsx')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          })
        }
      });
    },
    // 获取数据
    _GetCardRecordList() {
      this.tableLoading = true
      GetCardRecordList({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        startTime: this.dateTimeRange[0].format('YYYY-MM-DD HH:mm:ss'),
        endTime: this.dateTimeRange[1].format('YYYY-MM-DD HH:mm:ss'),
        search: this.searchText,
        type: this.recordType,
        consumeType: this.consumeType,
        cardTypeId: this.cardType,
        departmentId: this.selectDepartment
      }).then(res => {
        const resault = res.data.attribute
        this.tableLoading = false
        this.tableData = []
        this.pagination.total = resault.pageCount

        this.baseInfo = {
          recharge: resault.recharge + '/' + resault.rechargeCount,
          consume: resault.consume + '/' + resault.consumeCount,
          withdrawCard: resault.withdrawCard + '/' + resault.withdrawCardCount,
          openAccount: resault.openAccount + '/' + resault.openAccountCount
        }
        resault.rows.forEach(item => {
          this.tableData.push({
            key: item.id,
            time: item.createTime.split('T')[0] + ' ' + item.createTime.split('T')[1].split('.')[0],
            idCard: item.cardId,
            staffName: item.name,
            recharge: item.cardRecordType === 1 ? '￥' + item.changeValue : '-',
            expend: item.cardRecordType === 2 ? '￥' + item.changeValue : '-',
            openAccount: item.cardRecordType === 3 ? '￥' + item.changeValue : '-',
            closeAccount: item.cardRecordType === 4 ? '￥' + item.changeValue : '-',
            balance: '￥' + item.changeBalance
          })
        });
      },
        res => {
          this.tableLoading = false;
        })
    },
    // 获取部门下拉
    _GetDepartmentDropdownList() {
      GetDepartmentDropdownList().then(res => {
        this.departmentList = res.data.attribute
      })
    }

  },
  created() {
    this._getCardTypeList()
    this._GetCardRecordList()
  },
  mounted() {
    this._GetDepartmentDropdownList()
  },
  components: {
    HeadInfo
  }
}

</script>

<style lang="less">
// 覆盖antd样式
.ant-table-small
  > .ant-table-content
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th {
  background: #fafafa !important;
}

.ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0 !important;
}

.selectTypeGroup > .ant-radio-button-wrapper {
  padding: 0 8px;
}
</style>
